<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError != '' ? 'box-border-color':''"
            @input="handleInput($event)"
            label="text"
            track-by="value"
            :multiple="false"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :searchable="true"
            :disabled="disabled">
            <span slot="noOptions">
                {{ $t('no_options') }}
            </span>
            <span slot="noResult">
                {{ $t('no_result') }}
            </span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError">
        </span>
    </div>
</template>

<script>
// Helpers
import handleInput from "@/helpers/handleInput";
import setSelected from "@/helpers/setSelected";

// Services
import GraduateApplicationService from "@/services/GraduateApplicationService";
import qs from "qs";
import ConstantService from "@/services/ConstantService";

export default {
    props: {
        value: {
            default: null
        },
        validateError: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        program_code: {
            default: null
        }
    },
    watch: {
        value: function (newValue) {
            this.selected = this.setSelected(newValue, this.options)
        },
        program_code: function () {
            this.getGraduateApplicationSemester()
        },
    },
    data() {
        return {
            selected: this.value,
            options: []
        }
    },
    created() {
       this.getGraduateApplicationSemester()
    },
    methods: {
        handleInput: handleInput,
        setSelected: setSelected,
        getOptions(semester_id) {
            const config = {
                params: {
                    'filter[semester_id]': semester_id,
                    'filter[program_code]': this.program_code,
                    limit: -1
                },
            };
            this.options = [];
            GraduateApplicationService.getAll(config).then(response => {
                const data = response.data.data;
                data.map(item => {
                    this.options.push({
                        value: item.id,
                        text: item.name + " " + item.surname,
                    });
                });
            }).then(() => {
                this.selected = this.setSelected(this.value, this.options)
            })
        },
        getGraduateApplicationSemester(){
            const config = {
                params: {
                    key:'graduate_application.semester_id'
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            ConstantService.getValue(config)
                .then(response=>{
                    this.getOptions(response.data.data)
                }).catch(err=>{
                this.showErrors(err)
            })
        }
    }
}
</script>
